import React from 'react';
import Link from '@material-ui/core/Link';
import { Constants } from '../utils/constants';

export default function Guides(props) {
	const linkConfig = [
		{
			_id: 'app',
			text: 'RoadAI mobile application user guide',
			url: Constants.appGuideUrl
		},
		{
			_id: 'data_collection',
			text: 'Mobile Data Collection Guidelines & Equipment Installation',
			url: Constants.dataCollectionGuideUrl
		},
		{
			_id: 'map',
			text: 'RoadAI Map user guide',
			url: Constants.mapGuideUrl
		}
	];

	const links = linkConfig.map(link => (
		<Link
			key={link._id}
			href={link.url}
			target="_blank"
			rel="noopener"
			display="block"
			gutterBottom
		>
			{link.text}
		</Link>
	));

	return <React.Fragment>{links}</React.Fragment>;
}
